import React from 'react'
import Cookies from 'universal-cookie';
import {broadcast, listen, stop_listen, post_gql, IS_DEV} from '../../utils'
import './index.css'

const get_profile = (token) => {
  post_gql(
    `query { getProfile{ id name email picture }}`,
    resp => {
      const user = resp.data.data.getProfile
      broadcast("current_user", {...user, access_token: token})
    },
    {"authorization": `Bearer ${token}`}
  )
}

class Auth extends React.Component {
  constructor(props) {
    super(props)

    const cookies = new Cookies();
    const token = cookies.get('atoken')

    if (token && token !== '') {
      this.state = {token: token, listners: []}
      get_profile(token)
    } else {
      this.state = {token: '', listners: []}
    }
  }

  componentDidMount(){
    const listners = [
      {type: "toolbar_mode_change", fnc: ({detail}) => this.setState({mode: detail.mode})}
    ]

    const cookies = new Cookies();

    var map_token = window.location.pathname.replace("/t/", "")

    if (map_token !== "" && map_token !== "/")
      cookies.set('map_token', map_token, { path: '/' });

    const urlParams = new URLSearchParams(window.location.search);
    var atoken = urlParams.get('access_token');
    var rtoken = urlParams.get('refresh_token');

    if (atoken) {
      cookies.set('atoken', atoken, { path: '/' });
      cookies.set('rtoken', rtoken, { path: '/' });
      this.setState({token: atoken})
      get_profile(atoken)
    }

    listners.forEach(l => listen(l.type, l.fnc))
    this.setState({listners})
  }

  componentWillUnmount(){this.state.listners.forEach(l => stop_listen(l.type, l.fnc))}

  render() {
    if (this.state.token !== ''){
      return(
        null
      )
    } else {
      return(
        <div className="auth-cont">
          <h1>Авторизация</h1>
          <a
            className="google-auth"
            href={
              IS_DEV ?
                "https://accounts.google.com/o/oauth2/v2/auth?response_type=code&prompt=consent&access_type=offline&scope=profile%20email&client_id=235092686272-k37h6etpoomalu0ohh9tkgpt2fde0s64.apps.googleusercontent.com&redirect_uri=http%3A%2F%2Flocalhost:4000%2Fauth%2Fgoogle%2Fcallback"
                : "https://accounts.google.com/o/oauth2/v2/auth?response_type=code&prompt=consent&access_type=offline&scope=profile%20email&client_id=235092686272-k37h6etpoomalu0ohh9tkgpt2fde0s64.apps.googleusercontent.com&redirect_uri=http%3A%2F%2Fback.gjsn.ru%2Fauth%2Fgoogle%2Fcallback"
            }
          >
            <svg width="32px" height="32px" viewBox="-3 0 262 262" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid">
              <path d="M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622 38.755 30.023 2.685.268c24.659-22.774 38.875-56.282 38.875-96.027" fill="#4285F4"/>
              <path d="M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055-34.523 0-63.824-22.773-74.269-54.25l-1.531.13-40.298 31.187-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1" fill="#34A853"/>
              <path d="M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82 0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602l42.356-32.782" fill="#FBBC05"/>
              <path d="M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0 79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251" fill="#EB4335"/>
            </svg>
            <span>Войти через google</span>
          </a>
        </div>
      )
    }
  }
}

export default Auth;
